__turbopack_context__.v({
  "VideoPreview": "post-video-preview-module__RZoHlq__VideoPreview",
});
